import { getFuturesPnlApi } from '@/api/exchangesApi';
import { QUERY_REFETCH_INTERVAL } from '@/lib/constants';

export const futurePnlQueryKey = (accountId: number) => ['futurePnl', accountId] as const;

export const futurePnlQuery = (accountId: number) => ({
    queryKey: futurePnlQueryKey(accountId),
    queryFn: async (): Promise<number> => {
        const { data } = await getFuturesPnlApi(accountId);
        return data.pnl;
    },
    staleTime: QUERY_REFETCH_INTERVAL,
});
